import React from 'react';
import ProcessSection from '../components/ProcessSection';

export default function ProcessPage() {
  return (
    <div className="page-container">
      <section className="page-header section-dark">
        <div className="section-content">
          <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
            <div className="section-eyebrow">Our Methodology</div>
            <h1 style={{ fontSize: '48px', marginBottom: '24px' }}>From Capture to Submission</h1>
            <p style={{ fontSize: '20px', color: 'var(--text-secondary)' }}>
              A proven, disciplined approach that transforms your technical capabilities into winning proposals.
            </p>
          </div>
        </div>
      </section>

      <ProcessSection />
    </div>
  );
}
